import React from 'react';
import { useTranslate } from '@hooks';
import { FlexContainer } from '@dotone/react-ui-core';
import { Table } from 'reactstrap';
import Trans from 'next-translate/Trans';

const SinglePointConversionsTab = () => {
  const { t } = useTranslate('uploadInstruction');
  return (
    <>
      <FlexContainer>
        <span className="text-warning">{t('templateFile')}:</span>
        <ul className="d-flex">
          <li>
            <a
              target="_blank"
              href="https://cdn.affiliates.one/docs/assign-credit-affiliates.csv"
              rel="noreferrer"
            >
              {t('singlePointTable.approvingRejectingConversions')}
            </a>
          </li>
        </ul>
      </FlexContainer>
      <p>{t('singlePointTable.usage')}</p>
      <Table bordered className="table-overview">
        <thead>
          <tr>
            <th scope="col">{t('tableHeaders.columnNames')}</th>
            <th scope="col">{t('tableHeaders.descriptions')}</th>
            <th scope="col">{t('tableHeaders.notes')}</th>
            <th scope="col">{t('tableHeaders.required')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('common.rows.id.columnName')}</td>
            <td>{t('common.rows.id.description')}</td>
            <td>{t('singlePointTable.rows.id.notes')}</td>
            <td>
              <Trans
                i18nKey="uploadInstruction:required"
                components={[<strong key="required" />]}
              />
            </td>
          </tr>
          <tr>
            <td>{t('common.rows.approval.columnName')}</td>
            <td>{t('common.rows.approval.description')}</td>
            <td>
              <Trans
                i18nKey="uploadInstruction:common.rows.approval.notes"
                components={[<strong key="common.rows.approval.notes" />]}
              />
            </td>
            <td>
              <Trans
                i18nKey="uploadInstruction:required"
                components={[<strong key="required" />]}
              />
            </td>
          </tr>
          <tr>
            <td>{t('common.rows.capturedAt.columnName')}</td>
            <td>{t('common.rows.capturedAt.description')}</td>
            <td>
              <ul>
                <li>
                  <Trans
                    i18nKey="uploadInstruction:common.rows.capturedAt.notes.note1"
                    components={[<strong key="common.rows.capturedAt.notes.note1" />]}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="uploadInstruction:common.rows.capturedAt.notes.note2"
                    components={[<strong key="common.rows.capturedAt.notes.note2" />]}
                  />
                </li>
              </ul>
            </td>
            <td>{t('optional')}</td>
          </tr>
          <tr>
            <td>{t('common.rows.truePay.columnName')}</td>
            <td>{t('common.rows.truePay.description')}</td>
            <td>
              {t('singlePointTable.rows.truePay.notes.note1')}
              <br />
              {t('common.rows.truePay.notes.note3')}
              <br />
              {t('common.rows.truePay.notes.note4')}
            </td>
            <td>{t('optional')}</td>
          </tr>
          <tr>
            <td>{t('common.rows.affiliateId.columnName')}</td>
            <td>{t('singlePointTable.rows.affiliateId.description')}</td>
            <td>
              <Trans
                i18nKey="uploadInstruction:singlePointTable.rows.affiliateId.notes"
                components={[<strong key="singlePointTable.rows.affiliateId.notes" />]}
              />
            </td>
            <td>{t('optional')}</td>
          </tr>
        </tbody>
      </Table>
      <h5>{t('csvExample')}</h5>
      <Table bordered>
        <thead>
          <tr>
            <th>captured_at ({t('optional')})</th>
            <th>offer_id</th>
            <th>order_number ({t('optional')})</th>
            <th>order_total</th>
            <th>true_pay</th>
            <th>step_name ({t('optional')})</th>
            <th>approval</th>
            <th>id</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('dateFormat')}</td>
            <td>2345</td>
            <td>LEAD55678</td>
            <td>100</td>
            <td>2</td>
            <td>default/sale</td>
            <td>Pending/Rejected/Approved</td>
            <td>{t('id')}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default SinglePointConversionsTab;
